import api from './api';

/** Perguntas do agendamento. Pergunta não é editável: a única edição é o rótulo. */
const customFieldsService = {
  list: async () => {
    const { data } = await api.get('/customfields');
    return data;
  },

  create: async (payload) => {
    const { data } = await api.post('/customfields', payload);
    return data;
  },

  /** Liga um dado básico (colunas de persons). */
  createSystem: async (systemKey, payload) => {
    const { data } = await api.post(`/customfields/system/${systemKey}`, payload);
    return data;
  },

  rename: async (id, label) => {
    await api.patch(`/customfields/${id}/label`, { label });
  },

  setActive: async (id, isActive) => {
    await api.patch(`/customfields/${id}/active`, { isActive });
  },

  reorder: async (ids) => {
    await api.put('/customfields/order', { ids });
  },

  remove: async (id) => {
    await api.delete(`/customfields/${id}`);
  },

  forBooking: async ({ professionalId, placeId, serviceId }) => {
    const { data } = await api.get('/customfields/for-booking', { params: { professionalId, placeId, serviceId } });
    return data;
  },

  getAppointmentAnswers: async (appointmentId) => {
    const { data } = await api.get(`/appointments/${appointmentId}/custom-field-answers`);
    return data;
  },

  /** Só as respostas alteradas: validar as outras travaria em resposta de pergunta já apagada. */
  saveAppointmentAnswers: async (appointmentId, answers) => {
    await api.put(`/appointments/${appointmentId}/custom-field-answers`, { answers });
  },

  getPersonFields: async (personId) => {
    const { data } = await api.get(`/persons/${personId}/custom-fields`);
    return data;
  },

  /** action: 'apply' grava na ficha, 'ignore' fecha o aviso. */
  resolveDivergence: async (valueId, action) => {
    await api.post(`/customfields/values/${valueId}/resolve`, { action });
  },
};

export default customFieldsService;
